import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import PropTypes from "prop-types";
function IdleModal({ open, handleContinue, handleLogout, getRemainingTime }) {
  const [timeLeft, setTimeLeft] = useState(60);
  useEffect(() => {
    const interval = setInterval(() => {
      console.log(Math.max(getRemainingTime() - 60));
      setTimeLeft(Math.trunc(getRemainingTime() / 1000));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  return (
    <React.Fragment>
      <Dialog open={open}>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your session will expire in{" "}
            <b>
              {timeLeft} second{timeLeft > 1 ? "s" : ""}
            </b>
            .
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleLogout}>
            Ok
          </Button>
          <Button variant="contained" onClick={handleContinue}>
            Extend Session
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

IdleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleContinue: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  getRemainingTime: PropTypes.func.isRequired,
};

export default IdleModal;
